<template>
  <div id="app">
     <v-app>
      <v-content>
        <v-container>
              <!-- <HelloWorld/> -->
              <Trafficlight/>
        </v-container>
      </v-content>
    </v-app>
  </div>
</template>

<script>
// import HelloWorld from './components/HelloWorld.vue'
import Trafficlight from './components/Trafficlight.vue'

export default {
  name: 'app',
  components: {
    // HelloWorld
    Trafficlight
  }
}
</script>

<style>
</style>
